<!-- Ported from the Polaris kit: src/product/components/ConfirmButton.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A button that asks once more, where it stands, and then acts. For a small thing that cannot be undone (delete a rule, remove a member)
// where a whole dialog would be too much. The question says what will happen; Escape or clicking away is "no".
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

defineProps({
  label: { type: String, required: true }, // "Delete rule"
  question: { type: String, required: true }, // "Delete this note? This cannot be undone."
  confirmLabel: { type: String, default: '' }, // defaults to the label
  variant: { type: String, default: 'outline' },
  size: { type: String, default: 'sm' },
  ariaLabel: { type: String, default: '' }, // the name of the trigger when its words are shorter than the label ("Delete")
});
const emit = defineEmits(['confirm']);
const { t } = useI18n();
const open = ref(false);
const yes = () => {
  open.value = false;
  emit('confirm');
};
</script>

<template>
  <Popover v-model:open="open">
    <PopoverTrigger as-child>
      <Button
        type="button"
        :variant="variant"
        :size="size"
        :aria-label="ariaLabel || undefined"
        data-confirm-button
      >
        <slot>{{ label }}</slot>
      </Button>
    </PopoverTrigger>
    <PopoverContent
      class="grid w-64 gap-3"
      role="alertdialog"
      :aria-label="label"
    >
      <p class="type-polaris-body">{{ question }}</p>
      <div class="flex justify-end gap-2">
        <Button type="button" variant="outline" size="sm" @click="open = false">
          {{ t('POLARIS.CONFIRM_BUTTON.CANCEL') }}
        </Button>
        <Button type="button" variant="destructive" size="sm" @click="yes">
          {{ confirmLabel || label }}
        </Button>
      </div>
    </PopoverContent>
  </Popover>
</template>
